import React, { useEffect } from 'react';
import { func, shape } from 'prop-types';
// import { useParams } from 'react-router-dom';

import Button from 'components/common/Button/Button';
import Header from 'components/header/Header/Header';
import PodcastInfo from 'components/series/SerieInfo/PodcastInfo';
import UnlockPodcastButton from 'components/unlock/unlockPodcastButton';
import BackgroundOpacity from 'components/common/BackgroundOpacity/BackgroundOpacity';

import { routesPaths } from 'constants/routesPaths';
import { PURCHASE_TYPES } from 'constants/constants';
import { podcastShape, unlockContentConfigShape, celebrityInfoShape } from 'constants/propTypesShapes';

import usePodcast from 'hooks/usePodcast';
import { useIsMobile, useNavigation } from 'hooks';
import useMembership from 'hooks/celebrities/useMembership';

import { renderImage, routeWithProps } from 'utils/helpers';

// const PROFILE_IMAGE_SIZE = 140;

const UnlockPodcastLanding = ({ podcast, config, celebrity, onSuccess }) => {
  console.log("UnlockPodcastLanding Rendered");
  const isMobile = useIsMobile();
  const { goToWithSearch, goTo } = useNavigation();
  const { setPodcast, setFlowConfig } = usePodcast();
  const { getMembership } = useMembership();
  const { bannerImageUrl } = podcast;
  const {  username } = celebrity;

  useEffect(() => {
    const CURRENT_EPISODE = podcast;
    if (CURRENT_EPISODE) setPodcast(CURRENT_EPISODE);
    if (config) setFlowConfig(config);
      getMembership(celebrity.id);
    // }
  }, []);

  return (
    <>
      <Header />
      <div className="unlock-episode">
        <BackgroundOpacity background={renderImage(bannerImageUrl, bannerImageUrl)} opacity={0.5} />
        <div className="unlock-episode-gradient" />
        <div className="unlock-episode-content">
          <div className="left-content content-item">
            {config.purchaseType === PURCHASE_TYPES.PODCAST && (
              <>
                <h2 className="bold episode-title">
                  {config.title} for ${config.price}
                </h2>
                <h2 className="padding-top-episode-name">{config.episodeName}</h2>
              </>
            )}
            <div className="button-container">
              <UnlockPodcastButton
                celebrity={celebrity}
                title={config.buttonLabel}
                size={isMobile ? 'large' : 'small'}
                onSuccess={() =>  
                  onSuccess?.()
              }
              />
              <Button
                labelId="earlyRelease.watchAnotherPodcast"
                type="secondary"
                size={isMobile ? 'large' : 'small'}
                onClick={() =>
                  goToWithSearch(
                    routeWithProps(routesPaths.celebrityId, { username: username.toLowerCase() }), `?tab=4`
                  )
                }
              />
            </div>
          </div>
          <PodcastInfo podcast={podcast} hideDescription className="content-item" />
        </div>
      </div>
    </>
  );
};

UnlockPodcastLanding.propTypes = {
  podcast: shape(podcastShape).isRequired,
  config: shape(unlockContentConfigShape).isRequired,
  celebrity: shape(celebrityInfoShape),
  onSuccess: func
};

export default UnlockPodcastLanding;
